import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_11782mgvt5: FaireBrandEntity = {
  token: "b_11782mgvt5",
  type: "brand",
  name: "LA Society",
  avatarUrl:
    "https://cdn.faire.com/fastly/3816a9dc8c1b00fab6ccab0a447f8673f1291a4b9c6a3fa0add82624b13cebd2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bfdc0c2b738e199616c5e01fefd6210974976c908de2e1255a8c371935514553.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3816a9dc8c1b00fab6ccab0a447f8673f1291a4b9c6a3fa0add82624b13cebd2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bfdc0c2b738e199616c5e01fefd6210974976c908de2e1255a8c371935514553.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 237,
  isTopShop: true,
  isInsider: true,
  description:
    "WITH LOVE FROM THE HEART OF LA\n\nFunctional, flexible, flattering, feel-good fashion. That’s our passion. ❤️\n\nCome here to celebrate the personal path you’re traveling towards today and every day forward. \n\nCome here for clothes to live in.\n\nLA Society is a seasonally-updated, carefully curated casual and activewear collection designed to be ideal for the current-day lifestyles we lead now.\n\n📌 IMPORTANT INFORMATION:\n\nLABELS: All products come with size and care labels only. We offer custom labeling services; feel free to contact us. Our brand labels are available for free—please contact us after placing your order if you’d like them included.\n\nORDER PROCESSING TIME: All orders ship from Los Angeles, CA, and are typically processed within 2-4 business days.\n\nFor more information, don’t hesitate to get in touch! 😊",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:52.680Z",
    importedBy: "entity-db-cli",
  },
};
